var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagEn = function SvgFlagEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Flag_EN_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Flag_EN_svg__b",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Flag_EN_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00247D",
    d: "M-3 0h54v48H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.96 4.5-8 40.1V49l7.04-4.5L56 8.9V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.96 44.5-8 8.9V0l7.04 4.5L56 40.1V49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 0h14v48H17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-15 31.18V17.82h80v13.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-15 31.18V17.82h80v13.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF142B",
    d: "M20 0h8v48h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF142B",
    d: "M-16 28.5v-8h79.999v8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF142B",
    d: "M-16 28.5v-8h79.999v8zM-7.999 7.48V4.5L13.316 17.82v.001l-4.777-.001zM34.56 17.865h-4.8L51.142 4.501l4.685-2.95V4.5zM-3.2 44.5H-8l21.384-13.365h4.685zM55.998 41.523v2.98L34.683 31.18v-.001h4.778z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Flag_EN_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgFlagEn;